<template>
  <div v-if="tours && tours.length > 0" class="similar-tours-wrapper">
    <div class="tour-type-title">
      <h2 class="tour-list-title red">Similar tours</h2>
    </div>
    <div class="tour-list-wrapper">
      <TourSlider
        :id="`similar-tour-slider`"
        class="similar-tours-slider"
        :list="tours"
        :card-width="cardWidth"
      >
        <template #content="{ item }">
          <div class="card-wrapper">
            <FeaturedCity :key="item.tourPageTitleShort" :values="item" />
          </div>
        </template>
      </TourSlider>
    </div>
  </div>
</template>
<script>
import TourSlider from '@/components/containers/tour/TourSlider'
import FeaturedCity from "@/components/utils/FeaturedCity"
export default {
  name: "SimilarTours",
  components: {
    TourSlider,
    FeaturedCity
  },
  props: {
    tours: {
      type: Array,
      default: false
    }
  },
  data() {
    return {
      cardWidth: 428
    }
  }
}
</script>

<style lang="scss" scoped>
.similar-tours-wrapper {
  .tour-list-items {
    // height: 424px;
  }
  .card-wrapper {
    width: 85%;
  }
}

@include max-width($tablet-portrait) {
  .similar-tours-wrapper .card-wrapper {
    width: 264px;
  }
}

</style>
